import { provider } from "@grassrootly/api/providers";
import { IUserPlayer } from "../../entities";

export type AuthenticatePayload = {
  email: string;
  password: string;
};

export const Authenticate = async (params: AuthenticatePayload): Promise<IUserPlayer> =>
  provider.Request<AuthenticatePayload, IUserPlayer>("/auth/login", params);
